/*
 * @fileOverView Gallery component definition
 */

import Masonry from 'masonry-layout'
import Vue from 'vue';
import imagesLoaded from 'vue-images-loaded'
import Throttle from 'utils/Throttle';
import {KeyCodes, Events, Intervals} from 'utils/Constants';
import Blazy from 'blazy';
import ViewportHelper from 'utils/ViewportHelper';

/**
 * [Modal Vue]
 * @type {class}
 */
Vue.component('gallery-vue', {
  directives: {
    imagesLoaded
  },

  data: function() {
    return {
      selectedIndex: -1
    }
  },

  created() {
    this.$window = $(window);
  },

  mounted() {
    const resizeCallback = Throttle(e => this.handleResize(), 200);
    this.$window.on(Events.RESIZE, resizeCallback);
  },

  methods: {
    /**
     * handle initialization
     * @return {void}
     */
    loaded() {
      this.loadMasonry();

      this.bLazy = new Blazy({
        container: '.gallery',
        //when reloading a page in the middle, scrolling to the top will never reveal the top items unless this is 0: default is 100
        offset: 0,
        success: (ele) => {
          setTimeout(function(){
            ele.classList.add('loadComplete');
            }, 200);
          }
      });
    },

    /**
     * Need to reflow the masonry when resizing
     * @return {void}
     */
    handleResize() {
      this.$nextTick(() => {
        this.loadMasonry();
        this.bLazy.revalidate();
      });
    },

    loadMasonry() {
      this.masonry = new Masonry(this.$refs.masonry, {
        columnWidth: '.gallery-item:first-child',
        itemSelector: '.gallery-item',
        gutter: ViewportHelper.isMobile() ? 0 : 40,
        percentPosition: true
      });
    },

    /**
     * handles selceting an item
     * @param  {Integer} item
     * @return {void}
     */
    selectItem(item) {
      this.selectedIndex = item;
    },

    /**
     * resets the index on the next frame
     */
    reset() {
      this.$nextTick(() => {
        this.selectItem(-1)
      });
    }
  }
});
